import { GOOGLE_MAPS_API_KEY } from './googleMaps'

/**
 * Single-location Google map iframes (plumber profile, job status).
 *
 * With the Maps key set we use the Maps Embed API, Google's supported embed:
 * free with unlimited loads, but it needs a key. Without one we fall back to the
 * undocumented `maps?q=…&output=embed` URL the pages used before (issue #97),
 * which works today but Google can change or drop at any time.
 */
export type MapEmbedTarget = { lat: number; lng: number } | { query: string }

/** Google's recommended policy for keyed embeds: the referrer restriction only
 *  needs our origin, and page paths (job IDs) never leave the site. */
export const MAP_EMBED_REFERRER_POLICY = 'strict-origin-when-cross-origin'

export function googleMapEmbedUrl(target: MapEmbedTarget, zoom?: number, key = GOOGLE_MAPS_API_KEY): string {
  const q = 'query' in target ? target.query : `${target.lat},${target.lng}`
  const apiKey = key?.trim()
  const params = new URLSearchParams()
  if (apiKey) {
    params.set('key', apiKey)
    params.set('q', q)
    if (zoom !== undefined) params.set('zoom', String(zoom))
    return `https://www.google.com/maps/embed/v1/place?${params}`
  }
  params.set('q', q)
  if (zoom !== undefined) params.set('z', String(zoom))
  params.set('output', 'embed')
  return `https://www.google.com/maps?${params}`
}
